"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _dicts = require("@package/dicts");

var _react = require("react");

function _default(accountId) {
  return (0, _react.useMemo)(function () {
    return _dicts.CURRENCY_NAMES.filter(function (item) {
      return item['id'] !== accountId;
    });
  }, [accountId]);
}